// constants/cookieKeys.js
export const COOKIE_KEYS = Object.freeze({
  PREFERENCES: "ft_cookie_preferences",
  ANALYTICS: "ft_cookie_analytics",
  // MARKETING: "ft_cookie_marketing",
});
